<div class="register_balance-container">
  @if (!allTransaction) {
  <div *ngIf="!isFromDistribution">
    <div class="register_balance-header">
      @if (screenWidth > 480) {
      <div>
        <h5>{{ data?.name }}{{ ' History' }}</h5>
      </div>
      }
      <div class="d-flex items-center">
        <div class="web__close-icon">
          <button type="button" class="close" data-dismiss="modal" (click)="closeDialog()">
            <span class="material-icons icons-close-mobile">close</span>
          </button>
        </div>
      </div>
    </div>
    @if (screenWidth <= 480) {
    <div class="d-flex register_balance-mobile-header">
      <div>
        <h5>{{ data.name }}{{ ' History' }}</h5>
      </div>
      @if (data.isEdit) {
      <button class="add-button">
        <mat-icon (click)="addNewEntry()">add</mat-icon>
      </button>
      }
    </div>
    }
  </div>
  } @if (screenWidth > 480) {
  <div
    class="register_balance-table"
    #tableContainer
    [class]="isExpenseIncomeCategoryDropdownOpen && isBrowserSafari && allTransaction ? 'overflow-hidden' : ''"
    [style.height]="data.registerType == 'balance' ? '83vh' : '81vh'"
  >
    @if (registerArray.length) {
    <form [formGroup]="RegisterForm" autocomplete="off">
      <ng-container formArrayName="RegisterRows">
        <table
          #table
          mat-table
          [dataSource]="dataSource"
          fixedLayout="true"
          [style.margin-bottom]="editCategoryClicked ? '1200px' : ''"
          [style.width]="getWidthInAllTransaction()"
        >
          <ng-container matColumnDef="date">
            <th
              mat-header-cell
              *matHeaderCellDef
              [style.width]="'35% !important'"
              [style.background-color]="isFromDistribution ? 'white !important' : ''"
              [ngClass]="{
                'bg-white !important': isFromDistribution
              }"
            >
              <div class="d-flex items-center justify-between w-[44%]">
                @if (data.isEdit && !allTransaction) {
                <mat-checkbox type="checkbox" class="checkbox-input" [checked]="selectAll" (change)="selectAllEntry($event)"> </mat-checkbox>
                }
                <div class="flex items-center gap-2">
                  <span class="date"> Date </span>
                  <!-- <span class="material-icons f25" [style.color]="defaultSort === 'date' ? '#25508e' : 'unset'" (click)="sortByDate()">
                      {{ sortedArrayByDate ? 'keyboard_arrow_up ' : 'keyboard_arrow_down' }}
                    </span> -->
                </div>
              </div>
            </th>
            <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element" [style.width]="'35% !important'">
              <div class="d-flex" [style.margin-bottom]="!RegisterForm.get('RegisterRows').value[i]?.isDateEditable ? '-18px' : ''">
                <mat-checkbox
                  type="checkbox"
                  class="checkbox-input"
                  formControlName="selected"
                  [style.padding-top]="!RegisterForm.get('RegisterRows').value[i]?.isDateEditable ? '7.5px' : '2px'"
                  (change)="selectEntry($event, RegisterForm, element, i)"
                >
                </mat-checkbox>
                <div class="flex items-center gap-4">
                  <span
                    class="ml-6"
                    style="border-radius: 4px"
                    [style.padding-top]="!RegisterForm.get('RegisterRows').value[i]?.isDateEditable ? '11px' : ' 5.5px'"
                  >
                    <img
                      [matTooltip]="RegisterForm.get('RegisterRows').value[i]?.updated_by"
                      matTooltipPosition="below"
                      src="{{
                        RegisterForm.get('RegisterRows').value[i]?.source_img
                          ? RegisterForm.get('RegisterRows').value[i]?.source_img
                          : '../../../../../../../../assets/images/default-merchant.png'
                      }}"
                      class="rounded-[50%] w-8 h-8"
                    />
                  </span>
                  @if (RegisterForm.get('RegisterRows').value[i]?.isDateEditable) {
                  <span (click)="editRegisterEntry(RegisterForm, i, 'editDate')">
                    {{ element.value.date | date : 'longDate' }}
                  </span>
                  } @if (!RegisterForm.get('RegisterRows').value[i]?.isDateEditable) {
                  <mat-form-field [appearance]="RegisterForm.get('RegisterRows').value[i]?.isDateEditable ? 'none' : 'outline'">
                    <!-- <span style="margin-top: -15px !important">{{ RegisterForm.get('RegisterRows').value[i]?.date }}</span> -->
                    <input
                      matInput
                      [matDatepicker]="picker"
                      [max]="todayDate"
                      formControlName="date"
                      style="width: 100% !important; padding-bottom: 2.4px !important"
                      (dateChange)="updateEntryEvent(RegisterForm, i, 'updateDate')"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker" style="color: #25508e !important"></mat-datepicker-toggle>
                    <mat-datepicker #picker disabled="false" (closed)="updateEntryEvent(RegisterForm, i, 'updateDate')"></mat-datepicker>
                    {{ picker.open() }}
                  </mat-form-field>
                  }
                </div>
              </div>
            </td></ng-container
          >
          <ng-container matColumnDef="value">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="text-align: end"
              [style.width]="'30% !important'"
              [style.padding-right]="'25px'"
              [style.background-color]="isFromDistribution ? 'white !important' : ''"
              [ngClass]="{
                'bg-white !important': isFromDistribution
              }"
            >
              {{
                registerKeys[0]?.title.toLowerCase() == 'distribution amount in usd'
                  ? 'Amount'
                  : registerKeys[0]?.title.toLowerCase() == 'contribution amount (in usd)'
                  ? 'Value'
                  : registerKeys[0]?.title
              }}
            </th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              [formGroup]="element"
              style="text-align: end; align-items: end; justify-content: end; font-weight: 700 !important"
              [style.width]="'25% !important'"
              [style.padding-right]="'25px'"
            >
              <div [style.margin-bottom]="!RegisterForm.get('RegisterRows').value[i]?.isAmountEditable ? '-20px' : ''">
                @if (RegisterForm.get('RegisterRows').value[i]?.isAmountEditable) {
                <span [style.color]="element?.value?.value >= 0 ? '#27ae60' : ''">
                  @if( registerKeys[0]?.title?.toLowerCase() === 'quantity'){
                  {{ element?.value?.value | number : '1.2-4' }}
                  }@else{
                  {{ element?.value?.value | currency : 'USD' : true : '1.2-4' }}
                  }
                  <!-- {{ element?.value?.value | currency : 'USD' : true : '1.2-4' }} -->
                  <!-- {{ getAttributeValue(i) | currency : 'USD' : true : '1.2-4' }} -->
                  <!-- val 1 -->
                </span>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="value_two">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="text-align: end"
              [style.width]="'30% !important'"
              [style.padding-right]="'25px'"
              [style.background-color]="isFromDistribution ? 'white !important' : ''"
              [ngClass]="{
                'bg-white !important': isFromDistribution
              }"
            >
              {{ registerKeys[1]?.title }}
            </th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              [formGroup]="element"
              style="text-align: end; align-items: end; justify-content: end; font-weight: 700 !important"
              [style.width]="'25% !important'"
              [style.padding-right]="'25px'"
            >
              <div [style.margin-bottom]="!RegisterForm.get('RegisterRows').value[i]?.isValueTwoEditable ? '-20px' : ''">
                @if (RegisterForm.get('RegisterRows').value[i]?.isValueTwoEditable) {
                <span
                  [style.color]="element.value?.valueTwo >= 0 ? '#27ae60' : ''"
                  [matTooltip]="element?.value?.valueTwo | json"
                  [ngClass]="{
                    'font-normal text-base': registerKeys[1]?.title?.toLowerCase() === 'distribution type'
                  }"
                >
                  @if( registerKeys[1]?.title?.toLowerCase() === 'quantity'){
                  {{ element?.value?.valueTwo | number : '1.2-4' }}
                  } @else if(registerKeys[1]?.title?.toLowerCase() === 'distribution type'){
                  {{ element?.value?.valueTwo | titlecase | truncateStrPipe : 21 }}
                  } @else{
                  {{
                    RegisterForm.get('RegisterRows').value[i]?.valueTwo ?? 0
                      | currency : RegisterForm.get('RegisterRows').value[i]?.currency ?? 'USD' : true : '1.2-4'
                  }}
                  }
                </span>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="add">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="text-align: end; align-items: end; justify-content: end"
              [style.width]="'10% !important'"
              [style.background-color]="isFromDistribution ? 'white !important' : ''"
              [ngClass]="{
                'bg-white !important': isFromDistribution
              }"
            >
              <button class="add-button" (click)="addNewEntry()" *ngIf="!isFromDistribution">
                <mat-icon style="padding-top: 3px !important">add</mat-icon>
              </button>
            </th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              [formGroup]="element"
              [style.width]="data.registerType == 'balance' ? '10% !important' : ''"
              style="text-align: end; align-items: end; justify-content: end"
            >
              <mat-icon style="padding-top: 3px !important" class="text-k-blue" [matMenuTriggerFor]="matMenu">more_vert</mat-icon>
              <mat-menu #matMenu="matMenu" yPosition="below" xPosition="before" class="dropdown-menu-panel">
                <button mat-menu-item class="popup-menu-item" (click)="editBalance(RegisterForm, i)">
                  <p class="menuitem-text m-0 gap-2 flex items-center">
                    <span class="material-icons material-icons-round menuitem-icon text-k-blue">edit</span>Edit
                  </p>
                </button>
                <button mat-menu-item class="popup-menu-item text-red-600" (click)="deleteBalance(RegisterForm, i)">
                  <p class="menuitem-text m-0 gap-2 text-red-600 flex items-center">
                    <span class="material-icons material-icons-round menuitem-icon text-red-600">delete</span>Delete
                  </p>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          <!-- moveToTrashApi -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr
            mat-row
            id="{{ i }}"
            *matRowDef="let row; index as i; columns: displayedColumns"
            [style.background-color]="row.category == 'savings' ? '#F2F2F2;' : ''"
            (click)="selectedRow = selectedRow === row ? null : row"
            [class]="{ 'hover-state': selectedRowIndex === i, 'verified-state': RegisterForm.get('RegisterRows').value[i]?.is_reviewed }"
          ></tr>
        </table>
        <!-- [class]="{ 'selected': row === selectedRow }" -->
      </ng-container>
    </form>
    } @else { @if (!showEmptyEntry) {
    <div class="mt-3" onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue = false">
      @for (item of loaderItems; track item) {
      <div>
        <div class="flex loader-body" id="{{ item.id }}">
          <div class="ph-item width-100per loader-body-item">
            <div class="ph-col-12" style="padding: 0px !important">
              <div class="ph-row">
                <div class="ph-col-2" style="margin-left: 10px; margin-right: 20px"></div>
                <div class="ph-col-2"></div>
                <div class="ph-col-2"></div>
                <div class="ph-col-1 empty" style="width: 5%"></div>
                <div class="ph-col-4 empty-mobile"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    } @if (showEmptyEntry) {
    <div>
      <div>
        <div class="no-balance">
          <img src="../../../../../../../assets/images/vault/files_zero_state.svg" alt="" />
          <p style="text-align: center">
            <span> Nothing to show here </span>
            <br />
          </p>
          @if (data.registerType == 'balance' && data.isEdit) {
          <button class="h-12 w-fit px-3" type="button" (click)="addNewEntry()">
            Update
            {{ data?.title ? data?.title : 'Value' }}
          </button>
          } @if (data.registerType == 'transaction' && data.isEdit && !allTransaction) {
          <div class="d-flex">
            <button class="h-12" type="button" (click)="addNewEntry('income')">Add Income</button>
            <span style="width: 10px"></span>
            <button class="h-12" type="button" (click)="addNewEntry('expense')">Add Expense</button>
          </div>
          }
        </div>
      </div>
    </div>
    } } @if (registerArray.length && noMoreEntry) {
    <div class="pt-8 mb-[-40px] d-flex justify-content-center align-items-center register_balance-buttons">
      <button (click)="getMoreData()" style="width: 140px">Load More</button>
    </div>
    }
  </div>
  }

  <div onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue = false">
    <task-checklist-floater
      [selectedTasksArray]="selectedEntryArray"
      [disableDeleteButton]="disableDeleteButton"
      [disableReviewButton]="disableReviewButton"
      [checkReviewStatus]="checkReviewStatus"
      [fromBalanceRegister]="data.registerType == 'balance'"
      [fromTransactionRegister]="data.registerType == 'transaction'"
      [selectedCategories]="selectedCategories"
      [canCreateIncomeExpense]="canCreateIncomeExpense"
      [transactionType]="transactionType"
      [disableCategoryButton]="disableCategoryButton"
      (categoryClicked)="(null)"
      (reviewClicked)="(null)"
      (deleteClicked)="deleteRegisterEntry()"
      (clearClicked)="closeTaskChecklist($event)"
    >
    </task-checklist-floater>
  </div>
</div>
